var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBook48Filled = function SvgIconBook48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 8.3H15.6a5.31 5.31 0 0 0-5.3 5.3v20.8c0 2.92 2.38 5.3 5.3 5.3h19.2c1.6 0 2.9-1.3 2.9-2.9V11.2c0-1.6-1.3-2.9-2.9-2.9ZM13.7 34.4c0-1.05.85-1.9 1.9-1.9h18.7v3.8H15.6a1.9 1.9 0 0 1-1.9-1.9ZM19 15.3h10v3.4H19v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconBook48Filled;